export enum LoginTimeoutEnum
{
    MaxValue = 17,
}